<template>
  <div v-if="confirm" class="q-pa-md q-gutter-sm">
    <q-dialog v-model="confirm" persistent transition-show="scale" transition-hide="scale">
      <q-card style="width: 300px">
        <div class="alert-box">
          <div class="alert-title">ALERT!!</div>
          <div class="alert-content">
            <div class="alert-text" style="text-align:center">
              Are you sure to delete
              <span
                class="bold"
              >{{`${selectedVehicle.brand && selectedVehicle.brand.name ? selectedVehicle.brand.name : ''}#${selectedVehicle.vin}`}}</span>
            </div>
            <div class="alert-actions">
              <q-btn flat @click="reset">CANCEL</q-btn>
              <q-btn flat :loading="loading" label="OK" @click="remove">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "../axios/index";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    reset() {
      this.selectedVehicle = {};
      this.confirm = false;
    },
    async remove() {
      try {
        this.loading = true;
        await axios.delete(`vehicle/${this.selectedVehicle.id}`);
        this.$store.commit("vehicle/DELETE_VEHICLE", this.selectedVehicle);
        this.$store.commit("millage/DELETE_SELECTED_VEHICLE",this.selectedVehicle.id)
        this.selectedVehicle = {};
        this.confirm = false;
        this.$q.notify({
          message: "Vehicle deleted.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive"
        });
      } catch (error) {
        console.log(error)
        this.$q.notify({
          message: "We can not delete vehicle.Something wrong.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    confirm: {
      get() {
        return this.$store.state.vehicle.confirm;
      },
      set(val) {
        this.$store.commit("vehicle/SET_CONFIRM", val);
      }
    },
    selectedVehicle: {
      get() {
        return this.$store.state.vehicle.selectedVehicle;
      },
      set(val) {
        this.$store.commit("vehicle/SET_SELECTED_VEHICLE", val);
      }
    }
  }
};
</script>